import { Box, Table, TableBody, TableCell, TableRow, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import parse from "html-react-parser";

import type { CoretexTheme } from "../theme";

const useStyles = makeStyles((theme: CoretexTheme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(1),
    },
    key: {
      color: theme.palette.mono.gray,
      fontSize: "10px",
      width: "62px",
      fontWeight: "normal",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    keyCell: {
      width: "62px",
      padding: 0,
      borderBottom: 0,
      paddingRight: theme.spacing(1),
      textAlign: "left",
      verticalAlign: "top",
    },
    value: {
      color: theme.palette.mono.white,
      fontSize: "10px",
      fontWeight: theme.typography.fontWeightBold as number,
    },
    valueCell: {
      padding: 0,
      borderBottom: 0,
      paddingLeft: theme.spacing(1),
      maxWidth: "94px",
      overflowWrap: "break-word",
    },
    template: {
      fontSize: `10px !important`,
      color: `${theme.palette.mono.white} !important`,
      fontWeight: theme.typography.fontWeightBold as number,
      fontFamily: theme.typography.fontFamily,
    },
  }),
);

interface SecondaryLabelProps {
  id: string;
  records?: Record<string, string>;
  template?: string;
}

const SecondaryLabel = ({ id, records, template }: SecondaryLabelProps): JSX.Element => {
  const classes = useStyles();

  if (template) {
    return <Box className={clsx(classes.root, classes.template)}>{parse(template)}</Box>;
  }

  return (
    <Table className={classes.root}>
      <TableBody>
        {records &&
          Object.keys(records)
            .filter((r) => records[r] && records[r] !== "")
            .map((key: string) => {
              const item = records[key];
              return (
                <TableRow key={`secondaryLabel-${id}-${key}`} data-testid={`secondaryLabel-${id}-${key}`}>
                  <TableCell className={classes.keyCell}>
                    <Typography className={classes.key} noWrap>
                      {key}
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.valueCell}>
                    <Typography className={classes.value}>{item}</Typography>
                  </TableCell>
                </TableRow>
              );
            })}
      </TableBody>
    </Table>
  );
};
export default SecondaryLabel;
